import Account from "./Account";
import Chat from "./Chat";
import Help from "./Help";
import Integrating from "./Integrating";
import SettingsHeading from "./SettingsHeading";

const Settings = () => {
  return (
    <div>
      <SettingsHeading />
      <Account />
      <Chat />
      <Integrating />
      <Help />
    </div>
  );
};

export default Settings;
